import { DecryptData } from "./encryptDecrypt";

const RoleAccess = (allowedRole) => {
    let role = DecryptData(localStorage.getItem('role'))

    if (role && allowedRole?.length) {
        let authorised = allowedRole.find((f) => f.toLowerCase() === role.toLowerCase());
        if (authorised)
            return { authorised: true }
    }
    return { authorised: false }
}

export default RoleAccess